import { createSlice } from "@reduxjs/toolkit";

const threeSlice = createSlice({
  name: "home",
  initialState: {
    enable_source_move: true,
    enable_target_move: false,
    enable_position_change: true,
    mode: 0,
    threePop: {
      show: false,
      callback: () => {},
      check2: true,
    },
  },
  reducers: {
    setEnable_source_move: (state, action) => {
      state.enable_source_move = action.payload;
    },
    setEnable_target_move: (state, action) => {
      state.enable_target_move = action.payload;
    },
    setEnable_position_change: (state, action) => {
      state.enable_position_change = action.payload;
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setThreePop: (state, action) => {
      state.threePop = action.payload;
    },
  },
});

export const {
  setEnable_position_change,
  setEnable_source_move,
  setEnable_target_move,
  setMode,
  setThreePop,
} = threeSlice.actions;

export default threeSlice.reducer;
